import { j as o } from "../../../jsx-runtime-82a9ddf6.js";
const t = () => /* @__PURE__ */ o.jsxs("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ o.jsx("path", { d: "M7.80469 13.1992C10.7042 13.1992 13.0547 10.8487 13.0547 7.94922C13.0547 5.04972 10.7042 2.69922 7.80469 2.69922C4.90519 2.69922 2.55469 5.04972 2.55469 7.94922C2.55469 10.8487 4.90519 13.1992 7.80469 13.1992Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o.jsx("path", { d: "M15.4594 14.85L11.8594 11.25", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
] });
export {
  t as SearchIcon
};
